import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldCheck, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { COMPANY_AUTH } from "@/constants/testIds";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const [passwordSetupToken, setPasswordSetupToken] = useState(null);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Falta el token de verificación.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        setStatus("success");
        setMessage(data.message);
        if (data.password_setup_token) setPasswordSetupToken(data.password_setup_token);
      } catch (err) {
        setStatus("error");
        setMessage(formatApiErrorDetail(err.response?.data?.detail));
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <ShieldCheck className="w-7 h-7 text-petroleum" strokeWidth={1.5} />
          <span className="font-heading text-xl font-bold text-charcoal">CERH</span>
        </Link>
        <div className="bg-card border border-petroleum/10 rounded-2xl p-10 shadow-[0_8px_30px_rgba(14,79,79,0.08)]" data-testid={COMPANY_AUTH.verifyStatus}>
          {status === "loading" && <Loader2 className="w-10 h-10 text-petroleum animate-spin mx-auto" />}
          {status === "success" && <CheckCircle2 className="w-10 h-10 text-emerald-500 mx-auto mb-3" />}
          {status === "error" && <XCircle className="w-10 h-10 text-red-500 mx-auto mb-3" />}
          <p className="text-charcoal/80 mt-2">{message || "Verificando tu correo..."}</p>
          {status === "success" && passwordSetupToken && (
            <Link to={`/crear-contrasena?token=${encodeURIComponent(passwordSetupToken)}`} className="inline-block mt-6 bg-petroleum text-white font-semibold px-6 py-2.5 rounded-full">
              Continuar y crear mi contraseña
            </Link>
          )}
          {status === "success" && !passwordSetupToken && (
            <Link to="/login" className="inline-block mt-6 bg-petroleum text-white font-semibold px-6 py-2.5 rounded-full">
              Ir a iniciar sesión
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
